import olx from "../Pages/images/olx/olx.png";
import purple from "../Pages/images/purple/purple.png";
import maid1 from "../Pages/images/maidful/maid1.png";
import maid2 from "../Pages/images/maidful/maid2.png";
import maid3 from "../Pages/images/maidful/maid3.png";
import maid4 from "../Pages/images/maidful/maid4.png";
import maid5 from "../Pages/images/maidful/maid5.png";
import maid6 from "../Pages/images/maidful/maid6.png";
import maid7 from "../Pages/images/maidful/maid7.png";
import maid8 from "../Pages/images/maidful/maid8.png";
import maid9 from "../Pages/images/maidful/maid9.png";
import maid10 from "../Pages/images/maidful/maid10.png";
import maid11 from "../Pages/images/maidful/maid11.png";
import maid12 from "../Pages/images/maidful/maid12.png";
import maid13 from "../Pages/images/maidful/maid13.png";
import maid14 from "../Pages/images/maidful/maid14.png";
import maid15 from "../Pages/images/maidful/maid15.png";
import medi1 from "../Pages/images/medigreen/medi1.png";
import medi2 from "../Pages/images/medigreen/medi2.png";
import medi3 from "../Pages/images/medigreen/medi3.png";
import medi4 from "../Pages/images/medigreen/medi4.png";
import medi5 from "../Pages/images/medigreen/medi5.png";
import medi6 from "../Pages/images/medigreen/medi6.png";
import medi7 from "../Pages/images/medigreen/medi7.png";
import medi8 from "../Pages/images/medigreen/medi8.png";
import medi9 from "../Pages/images/medigreen/medi9.png";
import medi10 from "../Pages/images/medigreen/medi10.png";
import medi11 from "../Pages/images/medigreen/medi11.png";
import medi12 from "../Pages/images/medigreen/medi12.png";
import medi13 from "../Pages/images/medigreen/medi13.png";
import medi14 from "../Pages/images/medigreen/medi14.png";
import medi15 from "../Pages/images/medigreen/medi15.png";
import medi16 from "../Pages/images/medigreen/medi16.png";
import medi17 from "../Pages/images/medigreen/medi17.png";
import medi18 from "../Pages/images/medigreen/medi18.png";
import medi19 from "../Pages/images/medigreen/medi19.png";
import medi20 from "../Pages/images/medigreen/medi20.png";
import medi21 from "../Pages/images/medigreen/medi21.png";
import medi22 from "../Pages/images/medigreen/medi22.png";
import medi23 from "../Pages/images/medigreen/medi23.png";

import sun1 from "../Pages/images/sunglow/sun1.png";
import sun2 from "../Pages/images/sunglow/sun2.png";
import sun3 from "../Pages/images/sunglow/sun3.png";
import sun4 from "../Pages/images/sunglow/sun4.png";
import sun5 from "../Pages/images/sunglow/sun5.png";
import sun6 from "../Pages/images/sunglow/sun6.png";
import sun7 from "../Pages/images/sunglow/sun7.png";
import sun8 from "../Pages/images/sunglow/sun8.png";
import sun9 from "../Pages/images/sunglow/sun9.png";
import sun10 from "../Pages/images/sunglow/sun10.png";
import sun11 from "../Pages/images/sunglow/sun11.png";
import sun12 from "../Pages/images/sunglow/sun12.png";
import sun13 from "../Pages/images/sunglow/sun13.png";
import sun14 from "../Pages/images/sunglow/sun14.png";
import sun15 from "../Pages/images/sunglow/sun15.png";
import sun16 from "../Pages/images/sunglow/sun16.png";
import sun17 from "../Pages/images/sunglow/sun17.png";
import sun18 from "../Pages/images/sunglow/sun18.png";
import sun19 from "../Pages/images/sunglow/sun19.png";
import sun20 from "../Pages/images/sunglow/sun20.png";
import sun21 from "../Pages/images/sunglow/sun21.png";
import sun22 from "../Pages/images/sunglow/sun22.png";
import sun23 from "../Pages/images/sunglow/sun23.png";
import sun24 from "../Pages/images/sunglow/sun24.png";
import sun25 from "../Pages/images/sunglow/sun25.png";
import sun26 from "../Pages/images/sunglow/sun26.png";
import sun27 from "../Pages/images/sunglow/sun27.png";
import sun28 from "../Pages/images/sunglow/sun28.png";

export const projectdata = [
  {
    name: "Maidful Movement",
    img: [
      { id: 1, name: maid1 },
      { id: 2, name: maid2 },
      { id: 3, name: maid3 },
      { id: 4, name: maid4 },
      { id: 5, name: maid5 },
      { id: 6, name: maid6 },
      { id: 7, name: maid7 },
      { id: 8, name: maid8 },
      { id: 9, name: maid9 },
      { id: 10, name: maid10 },
      { id: 11, name: maid11 },
      { id: 12, name: maid12 },
      { id: 13, name: maid13 },
      { id: 14, name: maid14 },
      { id: 15, name: maid15 },
    ],
    type: "Group Project",
    desc: "This health and wellness web platform offers users a range of tools and features to help them reach their fitness goals. From tracking progress and creating workout routines to receiving nutritional guidance, the platform aims to support users in achieving better health and wellbeing.",
    techstack: "ReactJS, Typescript, Tailwindcss, Express, Mongoose, NodeJS",
    livelink: "https://maidfull-movement.vercel.app/",
    gitlink: "https://github.com/AyushiVashisth/maidful-movement",
  },
  {
    name: "Medi Green (1mg Clone)",
    img: [
      { id: 1, name: medi1 },
      { id: 2, name: medi2 },
      { id: 3, name: medi3 },
      { id: 4, name: medi4 },
      { id: 5, name: medi5 },
      { id: 6, name: medi6 },
      { id: 7, name: medi7 },
      { id: 8, name: medi8 },
      { id: 9, name: medi9 },
      { id: 10, name: medi10 },
      { id: 11, name: medi11 },
      { id: 12, name: medi12 },
      { id: 13, name: medi13 },
      { id: 14, name: medi14 },
      { id: 15, name: medi15 },
      { id: 16, name: medi16 },
      { id: 17, name: medi17 },
      { id: 18, name: medi18 },
      { id: 19, name: medi19 },
      { id: 20, name: medi20 },
      { id: 21, name: medi21 },
      { id: 22, name: medi22 },
      { id: 23, name: medi23 },
    ],
    type: "Group Project",
    desc: "1mg is a healthcare platform that provides access to a wide range of health products and services in India. The platform allows users to buy medicines, health supplements, and wellness products, book diagnostic tests and doctor consultations, and access health information and tools.",
    techstack:
      "ReactJS, JavaScript, HTML, CSS, Chakra UI, NodeJS, Express, Mongoose, MongoDB",
    livelink: "https://medigreenhealth.netlify.app/",
    gitlink: "https://github.com/AyushiVashisth/medi-green-health",
  },
  {
    name: "Sunglow Fashion       (Fashion and Beauty Clone)",
    img: [
      { id: 1, name: sun1 },
      { id: 2, name: sun2 },
      { id: 3, name: sun3 },
      { id: 4, name: sun4 },
      { id: 5, name: sun5 },
      { id: 6, name: sun6 },
      { id: 7, name: sun7 },
      { id: 8, name: sun8 },
      { id: 9, name: sun9 },
      { id: 10, name: sun10 },
      { id: 11, name: sun11 },
      { id: 12, name: sun12 },
      { id: 13, name: sun13 },
      { id: 14, name: sun14 },
      { id: 15, name: sun15 },
      { id: 16, name: sun16 },
      { id: 17, name: sun17 },
      { id: 18, name: sun18 },
      { id: 19, name: sun19 },
      { id: 20, name: sun20 },
      { id: 21, name: sun21 },
      { id: 22, name: sun22 },
      { id: 23, name: sun23 },
      { id: 24, name: sun24 },
      { id: 25, name: sun25 },
      { id: 26, name: sun26 },
      { id: 27, name: sun27 },
      { id: 28, name: sun28 },
    ],

    type: "Group Project",
    desc: "Sunglow Fashion is an e-commerce platform to buy clothes, beauty & Wellness, fashion, furniture and jewellery etc.",
    techstack: "React, Chakra UI, CSS",
    livelink: "https://unit-5-frontend-deployement.netlify.app/",
    gitlink: "https://github.com/ParbhatKataria1/responsible-act-7116",
  },
  {
    name: "Palm Beauty (Purplle Clone)",
    img: [
      { id: 1, name: purple },
      { id: 2, name: purple },
      { id: 3, name: purple },
      { id: 4, name: purple },
      { id: 5, name: purple },
      { id: 6, name: purple },
      { id: 7, name: purple },
    ],
    type: "Individual Project",
    desc: "Purple is a company that provides comfort and wellness products such as mattresses, seat cushions, and pillows. They utilize innovative technology and scientific research to create products that offer the ultimate comfort and support.",
    techstack: "JavaScript,HTML, CSS",
    livelink: "https://randombeauty.vercel.app/",
    gitlink: "https://github.com/AyushiVashisth/witty-pail-6017",
  },
  {
    name: "Olx Clone",
    img: [
      { id: 1, name: olx },
      { id: 2, name: olx },
      { id: 3, name: olx },
      { id: 4, name: olx },
      { id: 5, name: olx },
      { id: 6, name: olx },
      { id: 7, name: olx },
    ],
    type: "Group Project",
    desc: "OLX is a global online marketplace and classifieds platform that enables individuals and small businesses to buy and sell goods and services online. With a presence in over 45 countries and 40 languages, OLX offers a convenient platform for users to post their classified ads and interact with other buyers and sellers.",
    techstack: "HTML, CSS, JavaScript",
    livelink: "https://incandescent-cat-8eafe9.netlify.app/",
    gitlink: "https://github.com/gulam160/beneficial-spiders-5753",
  },
];
